/**
 * 資料異動通知（R28，照 CRM／PM／HR utils/dataEvents.ts）
 * 新增／編輯／刪除在 API「成功之後」呼叫 notifyDataChanged(topic)：
 * - 儀表板、報表每次進頁面都會背景重抓，只有開著的頁面需要靠事件更新
 * - accounts、bankAccounts：下拉選單重抓（別的對話框馬上看得到新科目、新帳戶）
 * - 發出事件：訂閱者（列表搜尋結果、目前開著的統計頁）各自重新載入
 * 對話框是樂觀更新，onClose 在 API 完成前就會觸發，重抓資料一律掛在這個事件上
 */
import { emitDataChanged, useDataChangedEvent } from '@redpanda/utils';
import { useAccountOptionsStore } from '../stores/accountStore';
import { useBankAccountOptionsStore } from '../stores/bankAccountStore';

export type DataTopic = 'accounts' | 'journals' | 'invoices' | 'bankAccounts' | 'bankTransactions' | 'periods';

export const notifyDataChanged = (topic: DataTopic) => {
  if (topic === 'accounts') useAccountOptionsStore.getState().fetchAll();
  if (topic === 'bankAccounts') useBankAccountOptionsStore.getState().fetchAll();
  emitDataChanged(topic);
};

/** 訂閱資料異動（共用實作 @redpanda/utils dataEvents）；handler 不需要 memo */
export const useDataChanged = (topic: DataTopic | DataTopic[], handler: () => void) => useDataChangedEvent(topic, handler);
